import type { ComponentType, ReactNode } from "react";
import {
	PolarAngleAxis,
	PolarGrid,
	PolarRadiusAxis,
	Radar,
	RadarChart,
	ResponsiveContainer,
	Tooltip,
} from "recharts";
import { fmtMoney } from "../../../shared/utils/campaign-metrics-format";

type PlacementRadarPoint = {
	placement: string;
	cost: number;
};

const tooltipStyle = {
	backgroundColor: "var(--window-background-color)",
	border: "1px solid var(--window-border-color)",
	borderRadius: 6,
	fontSize: 11,
	color: "var(--main-text-color)",
};

// recharts polar axes: React 19 JSX types
const RadarChartC = RadarChart as ComponentType<{
	data: PlacementRadarPoint[];
	children?: ReactNode;
}>;
const PolarGridC = PolarGrid as ComponentType<Record<string, unknown>>;
const PolarAngleAxisC = PolarAngleAxis as ComponentType<Record<string, unknown>>;
const PolarRadiusAxisC = PolarRadiusAxis as ComponentType<Record<string, unknown>>;
const RadarC = Radar as ComponentType<Record<string, unknown>>;

type Props = {
	data: PlacementRadarPoint[];
};

export const PlacementsRadarChart = ({ data }: Props) => (
	<ResponsiveContainer width='100%' height='100%'>
		<RadarChartC data={data}>
			<PolarGridC stroke='var(--window-border-color)' />
			<PolarAngleAxisC
				dataKey='placement'
				tick={{ fill: "var(--secondary-text-color)", fontSize: 10 }}
			/>
			<PolarRadiusAxisC
				tick={{ fill: "var(--secondary-text-color)", fontSize: 9 }}
			/>
			<RadarC
				dataKey='cost'
				name='Cost'
				stroke='#3db8d4'
				fill='#3db8d4'
				fillOpacity={0.35}
			/>
			<Tooltip
				contentStyle={tooltipStyle}
				formatter={(value) => {
					const raw =
						typeof value === "number" ? value : Number(value);
					return [
						fmtMoney(Number.isFinite(raw) ? raw : 0),
						"Cost",
					];
				}}
			/>
		</RadarChartC>
	</ResponsiveContainer>
);
